import React, { Component } from 'react';
import {connect} from 'react-redux';
import StationSearchResultsContainer from './StationSearchResultsContainer';
import Suggested from './Suggested';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class StationSearchContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {searchInput: ''};
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onSearchAllClick = this.onSearchAllClick.bind(this);
  }

  componentDidMount() {
  }

  renderBody(){
    return(
      <StationSearchResultsContainer
        selectResult={this.props.selectStationResult}
        oppositeDirectionCode={this.props.oppositeDirectionCode}
        suggestedHeader={this.props.suggestedHeader}
        withScheduledServiceHeader={this.props.withScheduledServiceHeader}
        searchInput={this.state.searchInput}
      />
    );
  }

  renderSearchAll() {
    if (
      !this.state.searchInput &&
      (
        this.props.with_scheduled_service_stations.length > 0 ||
        this.props.suggested_stations.length > 0
      )
    ) {
      return (
        <a
          href="javascript:void(0)"
          style={{display: 'block', fontWeight: 'bold', margin: '0 8px'}}
          className="btn btn-primary btn-inverse"
          onClick={this.onSearchAllClick}
        >
          {i18n.t('productSearch.searchAll')} {this.props.pointDescription}
        </a>
      );
    }
  }

  onSearchAllClick() {
    this.searchInput.focus();
  }

  onSearchInputChange(event) {
    this.setState({searchInput: event.currentTarget.value})
    this.props.searchStations(event);
  }

  render() {
    return (
      <div className="page-layout station-search">
        <div className="station-search-header">
          <div className="instruction">
            <span className="blade-x" onClick={this.props.cancelSearch} />
            <h2>{this.props.label}</h2>
          </div>
          <input
            ref={(i) => { this.searchInput = i; }}
            type="text"
            placeholder={this.props.placeholder}
            onChange={this.onSearchInputChange}
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
          />
        </div>
        <div className="page-layout-body">
          {this.renderBody()}
          {this.renderSearchAll()}
        </div>
      </div>
    );
  }

}

function mapStateToProps(state, ownProps) {
  return {
    loading: state.stationSearch.loading,
    query_performed: state.stationSearch.query_performed,
    suggested_stations: state.stationSearch.suggested_stations,
    with_scheduled_service_stations: state.stationSearch.with_scheduled_service_stations
  };
}

export default connect(mapStateToProps)(StationSearchContainer);
